import React, { useState, useContext } from 'react';
import { Outlet } from 'react-router-dom';
import { AuthContext } from '../../context/AuthContext';
import Sidebar from './Sidebar';
import Topbar from './Topbar';

const Layout = () => {
  const [isExpanded, setIsExpanded] = useState(false);
  const { user } = useContext(AuthContext);

  return (
    <div className="flex h-screen w-full overflow-hidden bg-gradient-to-br from-gray-100 to-white dark:from-gray-800 dark:to-gray-900">
      {/* Mobile overlay backdrop */}
      {isExpanded && (
        <div
          className="fixed inset-0 z-40 bg-black/40 md:hidden"
          onClick={() => setIsExpanded(false)}
        />
      )}

      {/* Sidebar */}
      <Sidebar isExpanded={isExpanded} setIsExpanded={setIsExpanded} />

      {/* Main content */}
      <div className={`flex flex-col flex-1 min-w-0 transition-[margin] duration-300 ${isExpanded ? 'md:ml-64' : 'md:ml-16'}`}>
        <Topbar isSidebarOpen={isExpanded} toggleSidebar={setIsExpanded} />
        <main className="flex-1 overflow-y-auto px-2 md:px-4 xl:px-8 mx-2 xl:mx-5">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default Layout;
